<template>
    <li>
        <a class="default-button"  @click="loadArquivos">
            <i class="mdi mdi-book-open-page-variant-outline"></i> 
            {{ documento.tipoDocumento }}
        </a>
        <div v-if="loadingArquivos">
            <p>
                <i class="mdi mdi-spin mdi-loading"></i>
            </p>
        </div>
        <div v-else-if="arquivos && arquivos.length == 0">
            <p>Nenhum arquivo</p>
        </div>
        <div v-else-if="arquivos && arquivos.length != 0">
            <ul>
                <Arquivo :arquivo="arquivo" :IdDocsprime="documento.IdDocsprime" v-for="arquivo in arquivos" :key="arquivo.id"></Arquivo>
            </ul>
        </div>
    </li>
</template>
<script>
import api from '/plugins/api'
import Arquivo from './arquivo.vue';
export default {
    props: ['documento'],
    components: {
        Arquivo
    },
    data() {
        return {
            arquivos: null,
            loadingArquivos: false,
            errors: []
        };
    },
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        }
    },
    methods: {
        async loadArquivos() {
            try {
                this.loadingArquivos = true;
                this.arquivos = [];
                let IdDocsprime = this.documento.IdDocsprime;

                if (!IdDocsprime) {
                    throw new Error("IdDocsprime not found");
                }
                if (!this.codigo_condominio) {
                    throw new Error("Cod Condominio not found");
                }


                let { data: arquivos } = await api.get(
                    `condominios/${this.codigo_condominio}/conta-corrente/${IdDocsprime}/lista-arquivos`
                );
                this.arquivos = arquivos;
                
            } catch (err) {
                this.errors = [...this.errors, err];
            }
            this.loadingArquivos = false;
        }
    }
}
</script>
<style lang="less" scoped>
    li {
        list-style: none;
        .default-button {
            margin: 0.5em;
            cursor: pointer;
            display: flex;
            align-items: center;
        }
        & > div {
            margin-left: 1em;
        }
    }
</style>